'use client';

import React, { useMemo } from 'react';
import Link from 'next/link';
import { getAssetSrc } from '@frontend/jetlend-web-ui/src/utils/getAssetSrc';
import CourseHeaderBadge from '@app/features/academy/course/CourseHeader/CourseHeaderBadge/CourseHeaderBadge';
import AchievementHeaderBadge from '@app/features/academy/course/CourseHeader/CourseHeaderBadge/AchievementHeaderBadge';
import Image from '@app/components/Image/Image';
import preview from '@app/icons/academy/course_preview.jpg';
import arrow from '@app/icons/arrow--green.svg';
import {
    IAchievementItemApiModel,
    ICourseInformationApiModel,
} from '@app/models/features/course';
import HeaderRecommendedSlider from './HeaderRecommendedSlider';
import { getAchievementsById } from '../../../academy.helper';

import styles from './HeaderRecommendedCourse.module.scss';

export interface IProps {
    /**
     * Список рекомендованных курсов
     */
    recommendedCourses: ICourseInformationApiModel[];
    /**
     * Список ачивок
     */
    achievements: IAchievementItemApiModel[];
}

/**
 * Компонент для отрисовки рекомендованных курсов
 */
const HeaderRecommendedCourse:React.FC<IProps> = props => {
    const {
        recommendedCourses,
        achievements,
    } = props;
    const achievementsMap = useMemo(() => getAchievementsById(achievements), [achievements]);

    return (
        <>
            <div className={styles['title']}>Рекомендуем</div>
            <HeaderRecommendedSlider>
                {recommendedCourses?.map(course => (
                    <div key={course.title} className={styles['wrapper']}>
                        <div className={styles['image-wrapper']}>
                            <Image className={styles['image']} src={getAssetSrc(preview)} alt="" fill />
                        </div>
                        <div className={styles['info-wrapper']}>
                            <div className={styles['card-title']}>{course.title}</div>
                            <div className={styles['badges']}>
                                <CourseHeaderBadge
                                    type="complexity"
                                    value={course?.complexity}
                                    size="small"
                                />
                                {course?.achievement_id && (
                                    <AchievementHeaderBadge
                                        value="+1 награда"
                                        size="small"
                                        achievementIcon={achievementsMap?.[course?.achievement_id]?.icon}
                                        achievementName={achievementsMap?.[course?.achievement_id]?.title}
                                    />
                                )}
                            </div>
                        </div>
                        <Link href={`/academy/courses/${course?.slug}`} className={styles['link']}><Image src={arrow} alt="" width={16} height={16} /></Link>
                    </div>
                ))}
            </HeaderRecommendedSlider>
        </>
    );
};

export default HeaderRecommendedCourse;